import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { generate } from "../../../routing/routes";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { serviceName } from "../../../data/booking/constants/service_types";
import moment from 'moment'
import cx from 'classnames'
import isEmpty from "lodash/isEmpty";
import { deleteDraft } from "../../../data/followup/actions/followup";
import { fetchDrafts } from "../../../data/account/actions/account";
import hikingImage from "../../../theme/img/bg/marcheurs2.jpeg";
import Modal from "./Modal";
import { PencilIcon, TrashIcon } from "@heroicons/react/20/solid";

const getEndUserName = (endUser) => {
    if (!isEmpty(endUser.firstName) && !isEmpty(endUser.lastName)) {
        return endUser.firstName + ' ' + endUser.lastName;
    }

    if (!isEmpty(endUser.firstName) && isEmpty(endUser.lastName)) {
        return endUser.firstName;
    }

    return endUser.lastName;
};

export default function TripCard({ trip, editable = false, isLoading = false, business = false }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    let isCancelled = trip.status =='cancelled';
    const dispatch = useDispatch();

    const picture = trip.mainRoute.thumbnail ? trip.mainRoute.thumbnail : hikingImage
    
    return (
        <>
            <Link to={!editable ? generate('customer_reservation', {reference: trip.reference}) : generate('book_edit', {reference: trip.reference})}>
                <div className={cx("group relative flex w-full items-center", {
                    "opacity-50": isCancelled || isLoading
                })}>
                    {editable && !isLoading && (
                        <div className="absolute top-0 right-0 hidden gap-4 group-hover:flex">
                            <PencilIcon
                                className="h-4 w-4 text-gray-400 transition hover:scale-150"
                                //onClick={() => window.location.href = generate('book_edit', {reference: trip.reference})}
                            />
                            <TrashIcon
                                className="h-4 w-4 text-gray-400 transition hover:scale-150"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    setOpen(true)
                                }}
                            />
                        </div>
                    )}
                    <div
                        className={"h-20 w-20 flex-none rounded-lg bg-cover bg-gray-100"}
                        style={trip.mainRoute.picture && {
                            backgroundImage: `url(${picture})`,
                        }}
                    />
                    <div className={"flex-initial px-2"}>
                        {(business && trip.endUser) && <p className={cx("font-bold text-orange-500", {
                            "line-through": isCancelled
                        })}>{getEndUserName(trip.endUser)}</p>}
                        <div className="w-fit">
                            <p className={cx("font-bold text-gray-800", {
                                "line-through": isCancelled,
                                "text-xs": business,
                            })}>{trip.mainRoute.title}</p>
                            <hr className="my-1 border-1 border-solid border-stone-300 w-full"/>
                        </div>
                        <p className={"mb-1 text-xs text-gray-600"}>
                            {moment(trip.startAt).format('DD/MM/YYYY')} {trip.endAt && <>- {moment(trip.endAt).format('DD/MM/YYYY')}</>}
                        </p>
                        <p className={"text-xs text-gray-600"}>
                            {trip.services.map((service, index) => (
                                <span key={index}>
                                    {index != 0 && " · "}
                                    {serviceName(service.type)}
                                </span>
                            ))}
                        </p>
                    </div>
                </div>
            </Link>
            <Modal title={`${t("booking.delete")} ?`} open={open} setOpen={setOpen} onConfirm={()=>{
                dispatch(deleteDraft(trip)).then(()=>{
                    if(!business){
                        dispatch(fetchDrafts())
                    }})
            }}>
                {t('booking.confirm_delete_drafts')}
            </Modal>
        </>
    );
}
